import { render, staticRenderFns } from "./summary-products-purchased-by-customer.vue?vue&type=template&id=335d8181&scoped=true&"
import script from "./summary-products-purchased-by-customer.vue?vue&type=script&lang=js&"
export * from "./summary-products-purchased-by-customer.vue?vue&type=script&lang=js&"
import style0 from "./summary-products-purchased-by-customer.vue?vue&type=style&index=0&id=335d8181&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335d8181",
  null
  
)

export default component.exports